module.exports = __webpack_public_path__ + "static/media/it-IT.e5cc8e76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-languages/it-IT.png
// module id = 949
// module chunks = 0